module.exports = __webpack_public_path__ + "static/media/rc-admin-icon.33e8a7b0.svg";